import { VerticalLanding, LandingConfig } from "./components/VerticalLanding";

// Nova Money — Meera, a 5-desk consumer-finance crew. The demo's spine is the
// CUSTOMER SEGMENT (Prime / Plus / Basic) plus the things a voice agent must
// refuse: it will block a lost card on the call and will never unblock one,
// and it never asks for an OTP, a PIN or a full card number.

const START = "/nurix-experience/experience?agent=nova-money&persona=nfx_NFX-C001&query=returned-payment&channel=web";

const CONFIG: LandingConfig = {
  startHref: START,
  mark: { initials: "NM", gradient: "linear-gradient(135deg, #0EA5E9 0%, #1D4885 100%)" },
  brandName: "Nova Money",
  brandTagline: "Meera · Customer Care",
  eyebrow: "BFSI — consumer finance",
  headline: "It blocks the card.",
  headlineAccent: "It will not unblock it.",
  intro: (
    <>
      Meet <span className="font-semibold" style={{ color: "var(--nx-text-1)" }}>Meera</span>, Nova Money's care associate across five desks —
      loans and EMIs, cards and disputes, payments and KYC. The interesting part of a finance agent is not what it does, it is what it refuses:
      push it to unblock a card or read out an OTP and watch it hold the line.
    </>
  ),
  features: [
    {
      gradient: "from-[#0EA5E9] to-[#1D4885]",
      icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
      ),
      title: "Irreversible things stay off the call",
      desc: "Blocking a lost card happens immediately. Unblocking never does — not with the right name, the right last four, or a caller who insists. No OTP, no PIN, no full card number, ever.",
    },
    {
      gradient: "from-[#34d399] to-[#059669]",
      icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      title: "The segment decides how fast money moves",
      desc: "A disputed charge gets Prime a provisional credit today. Basic gets seven to ten working days. Same script, same tools, different promise — because the policy says so, not the tone.",
    },
    {
      gradient: "from-[#fbbf24] to-[#f59e0b]",
      icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="13" y2="17" />
        </svg>
      ),
      title: "Loans, cards and payments in one voice",
      desc: "Foreclosure quotes, bounced EMIs, failed UPI transfers, KYC holds and limit reviews — five desks, one caller, and a case reference emailed before the call ends.",
    },
  ],
  card: {
    agentLine: "Meera — Customer Care",
    blurb: (
      <>
        Start as <span className="font-semibold" style={{ color: "var(--nx-text-1)" }}>Ananya Rao</span>, a Prime customer disputing a charge she
        does not recognise. Then run the same call as Rohan Verma on Basic and hear the credit timeline change. No account needed.
      </>
    ),
    rows: [
      { label: "Name", value: "Ananya Rao" },
      { label: "Segment", value: "Prime" },
      { label: "Issue", value: "Disputed transaction" },
    ],
    footnote: "No account required · Live segment-aware call",
  },
  footerLine: "Nova Money — consumer finance care demo",
};

export default function NovaLandingPage() {
  return <VerticalLanding config={CONFIG} />;
}
